import { Box, Divider, Fade, Portal, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import { default as React } from 'react'
import useScrollToggle from '../../../hooks/useNewScrollToggle'
import NewPagination from './NewPagination'

const portalContainerSx = {
  position: 'fixed',
  top: '48px',
  zIndex: 100,
  paddingLeft: '22px',
  paddingRight: '33px',
  width: '100vw',
}

type HeadPaginationProps = {
  totalSize: number
  contentLength: number
  store: any
  rowsPerPageOptions: number[]
  setRenderTable?: React.Dispatch<React.SetStateAction<boolean>>
  GroupOperationFeature?: React.ReactNode
}

function HeadPagination({
  totalSize,
  contentLength,
  rowsPerPageOptions,
  store,
  setRenderTable,
  GroupOperationFeature,
}: HeadPaginationProps) {
  const isSmallLength = contentLength < 50
  const scroll = useScrollToggle(200, 350)
  const showPagination = !isSmallLength || !!GroupOperationFeature

  return (
    <>
      {scroll && !isSmallLength && (
        <>
          <Portal>
            <Fade in={scroll}>
              <Box sx={portalContainerSx}>
                <Stack
                  direction={'row'}
                  justifyContent={
                    GroupOperationFeature ? 'space-between' : 'end'
                  }
                  padding={'16px'}
                  sx={{ backgroundColor: '#fff' }}
                >
                  {GroupOperationFeature && GroupOperationFeature}
                  <NewPagination
                    hidePageSign={totalSize < 50}
                    totalSize={totalSize}
                    rowsPerPageOptions={rowsPerPageOptions}
                    store={store}
                    setRenderTable={setRenderTable}
                  />
                </Stack>
              </Box>
            </Fade>
          </Portal>
        </>
      )}
      {showPagination && (
        <Stack
          direction={'row'}
          justifyContent={GroupOperationFeature ? 'space-between' : 'end'}
          padding={'16px'}
        >
          {GroupOperationFeature && GroupOperationFeature}
          <NewPagination
            hidePageSign={totalSize < 50}
            totalSize={totalSize}
            rowsPerPageOptions={rowsPerPageOptions}
            store={store}
            setRenderTable={setRenderTable}
          />
        </Stack>
      )}
      {showPagination && <Divider />}
    </>
  )
}

export default observer(HeadPagination)
